import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4d6jvdz5w2: FaireBrandEntity = {
  token: "b_4d6jvdz5w2",
  type: "brand",
  name: "Books by splitShops",
  avatarUrl:
    "https://cdn.faire.com/fastly/ecca4467557ab4fb411f037e5c217f850bd3e1ae26f6ccab87e9952469ce0a0b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8e9dd049c8f86c85789b3a8b7d8410525dd56bc1b595f6f6e39a49c12e7fc2dc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ecca4467557ab4fb411f037e5c217f850bd3e1ae26f6ccab87e9952469ce0a0b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8e9dd049c8f86c85789b3a8b7d8410525dd56bc1b595f6f6e39a49c12e7fc2dc.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.5,
  reviewCount: 55,
  isInsider: true,
  description: "Books for Your Store. Delivered to Every Door.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:23.460Z",
    importedBy: "entity-db-cli",
  },
};
